import { IconTrash } from "@tabler/icons-react";
import type { FC, MouseEvent } from "react";

import type { TChatListItem } from "@roko/ui/components/chat/types";
import { Tooltip } from "@roko/ui/components/tooltip/Tooltip";
import { cn } from "@roko/ui/lib/utils";

type TChatListItemRowProps = {
  chat: TChatListItem;
  isActive: boolean;
  deleteChatLabel: string;
  onSelect: () => void;
  onDelete: () => void;
};

export const ChatListItemRow: FC<TChatListItemRowProps> = ({
  chat,
  isActive,
  deleteChatLabel,
  onSelect,
  onDelete,
}) => {
  const handleDelete = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onDelete();
  };

  return (
    <div
      className={cn(
        "group grid grid-cols-[minmax(0,1fr)_2rem] items-center gap-1 rounded-lg py-2 pr-1 pl-2 hover:bg-muted/80",
        isActive && "bg-muted",
      )}
    >
      <Tooltip content={chat.title}>
        <button
          type="button"
          className="flex h-8 min-w-0 items-center overflow-hidden text-left text-sm text-foreground/90"
          onClick={onSelect}
        >
          <span className="truncate">{chat.title}</span>
        </button>
      </Tooltip>

      <button
        type="button"
        className="flex size-8 shrink-0 items-center justify-center rounded-md text-transparent transition-colors group-hover:text-foreground/50 hover:bg-muted hover:text-destructive"
        aria-label={deleteChatLabel}
        onClick={handleDelete}
      >
        <IconTrash className="size-4" stroke={1.75} />
      </button>
    </div>
  );
};
